import { faInfoCircle } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  Button,
  Card,
  CardContent,
  CardDescription,
  CardHeader,
  Tabs,
  TabsContent,
  TabsList,
  TabsTrigger
} from "alm-react-components";
import axios from "axios";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import {
  APPROUTES,
  BackendRespose,
  constants,
} from "../../../assets/constants/constants";
import {
  analytics_category,
  analytics_event,
  analytics_label,
} from "../../../assets/constants/staticContentConstants.ts";
import useGaEventTracking from "../../../hooks/UseGaEventTracking.tsx";
import { getCurrencySymbol } from "../../../lib/utils";
import { selectBillCycle, stripeHandle } from "../../../services/billingCycle";
import { endPoints, VITE_STATIC_CONTENT_URL } from "../../../services/urls.tsx";
import PageLoader from "../../common/loader/PageLoader";
import MemberShipModal from "./MemberShipModal";
type MemberShipPlanDetailType = {
  trialPeriodDays: number;
};

const MemberShipPlanDetails = (props: MemberShipPlanDetailType) => {
  const navigate = useNavigate();
  const { t } = useTranslation();
  const [billingCycle, setBillingCycle] = useState<any>([]);
  const [loading, setLoading] = useState(true);
  const [subscription, setSubscription] = useState<any>();
  const [billingType, setBillingType] = useState({
    type: "",
    amount: 0,
    name: "",
    description: [],
    currency: "",
  });
  const gaEventTracker = useGaEventTracking();

  useEffect(() => {
    const selectLanguage = localStorage.getItem("locale");
    const getSubscription = async () => {
      const resSubscription = await axios.get(
        `${VITE_STATIC_CONTENT_URL}/${endPoints.SUBSCRIPTION_VARIABLES}/${selectLanguage}.json`
      );
      setSubscription(resSubscription?.data?.subscription);
    };
    getSubscription();
  }, []);

  // const membershipDescription = [
  //   {
  //     priceId: "price_1P8FCrSBN32PmOWDhjhCu0vX",
  //     priceName: "YEARLY",
  //     amount: 180,
  //     currency: "usd",
  //     description: [
  //       subscription?.newContent || "MembershipDescription.newContent",
  //       subscription?.beTheFirstToKnow ||
  //         "MembershipDescription.beTheFirstToKnow",
  //       subscription?.getCuratedContent ||
  //         "MembershipDescription.getCuratedContent",
  //       subscription?.programReminders ||
  //         "MembershipDescription.programReminders",
  //       subscription?.classBadges || "MembershipDescription.classBadges",
  //       subscription?.learnWithExperts ||
  //         "MembershipDescription.learnWithExperts",
  //     ],
  //     trialPeriodDays: 0,
  //   },
  //   {
  //     priceId: "price_1P8FCBSBN32PmOWDOl7zYZXT",
  //     priceName: "MONTHLY",
  //     amount: 15,
  //     currency: "usd",
  //     description: [
  //       subscription?.newContent || "MembershipDescription.newContent",
  //       subscription?.beTheFirstToKnow ||
  //         "MembershipDescription.beTheFirstToKnow",
  //       subscription?.getCuratedContent ||
  //         "MembershipDescription.getCuratedContent",
  //       subscription?.programReminders ||
  //         "MembershipDescription.programReminders",
  //       subscription?.classBadges || "MembershipDescription.classBadges",
  //       subscription?.learnWithExperts ||
  //         "MembershipDescription.learnWithExperts",
  //     ],
  //     trialPeriodDays: 0,
  //   },
  // ];

  useEffect(() => {
    const handleBillingTypeApi = async () => {
      const response: any = await selectBillCycle({
        currency: localStorage.getItem("currency"),
      });
      setBillingCycle(response?.data);
      setBillingType({
        type: response?.data[0]?.price_Id,
        amount: response?.data[0]?.amount,
        name: response?.data[0]?.priceName,
        description: response?.data[0]?.description,
        currency: response?.data[0]?.currency,
      });
      setLoading(false);
    };
    handleBillingTypeApi();
  }, []);

  const onStripeHandle = async () => {
    const items = {
      value: null,
      currency:localStorage.getItem("currency"),
      transaction_id: null,
      items: [{}],
      plan_type:billingType?.name,
      pricing:billingType?.amount,
  };  
gaEventTracker(analytics_event.MembershipBillingSelection,analytics_category.buttonClickMembershipBillingSelection,analytics_label.membershipBillingSelectionLable,items);
    const billingname = billingType?.name.toUpperCase();
    const stripeInteral = {
      interval: billingname,
      currency: localStorage.getItem("currency"),
    };
    stripeHandle(stripeInteral)
      .then((res: any) => {
        const data = res.data;
        if (res.status === 200) {
          if (data.url !== "" && data.url) {
            window.open(data?.url, "_self");
          } else if (data.message === BackendRespose.alreadySubscribed) {
            navigate(APPROUTES.home);
          } else {
            navigate(`${APPROUTES.error}/unknonwError`);
          }
        }
      })
      .catch((error: any) => {
        console.log(error);
      })
      .finally(() => {
        setTimeout(() => {
          setLoading(false);
        }, 400);
      });
  };

  const onBillingTypeHandle = (
    priceId: string,
    amount: number,
    name: string,
    description: any,
    currency: string
  ) => {
    setBillingType({
      type: priceId,
      amount: amount,
      name: name,
      description: description,
      currency: currency,
    });
  };

  return (
    <>
      {loading ? (
        <PageLoader />
      ) : (
        <>
          {props.trialPeriodDays > 0 && (
            <div className="w-full text-center relative mt-6">
              <MemberShipModal
                billingType={billingType}
                trialPeriod={props?.trialPeriodDays}
                icon={
                  <FontAwesomeIcon
                    icon={faInfoCircle}
                    className="ml-2 h-5 w-5 font-light"
                  />
                }
                billingCycle={billingCycle}
              />
            </div>
          )}

          <Card className="text-base border-0 bg-transparent">
            <CardHeader className="block px-0">
              <div className="text-editor-dynamic-class font-barlowLight">
              <span
                  dangerouslySetInnerHTML={{
                    __html: subscription?.selectMembership,
                  }}
                />
                {/* <span
                  dangerouslySetInnerHTML={{
                    __html: subscription?.billingCycle,
                  }}
                /> */}
              </div>

                <span className="text-editor-dynamic-class"
                  dangerouslySetInnerHTML={{
                    __html: subscription?.setUpLearningSpace,
                  }}
                />
            </CardHeader>
            <CardContent className="px-0">
              <div >
                <Tabs defaultValue="annually">
                  <TabsList className="grid w-full h-auto grid-cols-2 border dark:text-white bg-fillMidGrayCard data-[state=active]:bg-fillDarkGrayCard">
                    {billingCycle &&
                      billingCycle.map((res: any) => (
                        <TabsTrigger
                          key={res?.id}
                          onClick={() =>
                            onBillingTypeHandle(
                              res?.priceId,
                              res?.amount,
                              res?.priceName,
                              res?.description,
                              res?.currency
                            )
                          }
                          className={
                            res?.priceName === billingType.name
                              ? "data-[state=active]:bg-fillDarkGrayCard"
                              : ""
                          }
                          value="annually"
                        >
                          {res?.priceName === "YEARLY"
                            ? t("BillingCycle.annually")
                            : res?.priceName === "MONTHLY"
                            ? t("BillingCycle.monthly")
                            : res?.priceName}
                        </TabsTrigger>
                      ))}
                  </TabsList>
                  <TabsContent value="annually" className="mt-4">
                    <Card>
                      <CardHeader className="bg-fillMidGrayCard rounded-t-xl">
                        <div className="tracking-wider">
                          <span className="text-editor-dynamic-class"
                            dangerouslySetInnerHTML={{
                              __html: subscription?.personalMembership,
                            }}
                          />
                        </div>

                        <CardDescription className="pb-3 text-base font-normal dark:text-white">
                          <span
                            dangerouslySetInnerHTML={{
                              __html: `${getCurrencySymbol(
                                billingType.currency
                              )} ${billingType?.amount.toFixed(2)}`,
                            }}
                          />
                          {" / "}
                          {billingType?.name === constants.YEARLY
                            ? t("BillingCycle.annually")
                            : t("BillingCycle.monthly")}
                        </CardDescription>

                        <Button
                          onClick={async () => {
                            setLoading(true);
                            await onStripeHandle();
                          }}
                          className="w-full h-auto py-2 text-base font-opensansSemiBold mt-6 mb-4"
                          dangerouslySetInnerHTML={{
                            __html: t("MembershipPlan.continue"),
                          }}
                        />
                      </CardHeader>
                      <CardContent className="px-8 py-4">
                        <div
                          className="mb-2 tracking-wider dynamic-unorderd-list "
                          dangerouslySetInnerHTML={{
                            __html:
                              billingType?.name === constants.YEARLY
                                ? subscription?.FeatureIncludeAnnually
                                : subscription?.FeatureIncludeMonthly,
                          }}
                        />

                        {/* <ul className="space-y-1 pb-3 text-left text-gray-500 dark:text-white">
                          {membershipDescription.map(
                            (item) =>
                              item.priceName === billingType.name && (
                                <div key={item.priceId}>
                                  {item.description.map((descKey, idx) => (
                                    <li
                                      key={idx}
                                      className="flex items-center space-x-3 rtl:space-x-reverse"
                                    >
                                      <svg
                                        className="flex-shrink-0 w-3.5 h-3.5 text-primary"
                                        aria-hidden="true"
                                        xmlns="http://www.w3.org/2000/svg"
                                        fill="none"
                                        viewBox="0 0 16 12"
                                      >
                                        <path
                                          stroke="currentColor"
                                          strokeLinecap="round"
                                          strokeLinejoin="round"
                                          strokeWidth={2}
                                          d="M1 5.917 5.724 10.5 15 1.5"
                                        />
                                      </svg>
                                      <span
                                        dangerouslySetInnerHTML={{
                                          __html: subscription?.beTheFirstToKnow,
                                        }}
                                      />
                                    </li>
                                  ))}
                                </div>
                              )
                          )}
                        </ul> */}
                      </CardContent>
                    </Card>
                  </TabsContent>
                </Tabs>
              </div>
            </CardContent>
          </Card>
        </>
      )}
    </>
  );
};

export default MemberShipPlanDetails;
